import { Controller } from '@hotwired/stimulus'

export default class Body extends Controller {
  static targets = ['navbar', 'navbarMenu']

  connect () {
    this.toggleClass = 'navbar__menu-active'
  }

  navbarToggle () {
    this.element.classList.toggle('body-overflow')
    this.navbarMenuTarget.classList.toggle(this.toggleClass)
  }
}
